/**
 * Les types de fichiers disponnible
 */
export enum CommonFileIcon {
  word = 0,
  pdf = 1,
  image = 2,
  unkown = 10,
}
